<template>
	<vx-card class="my-8 quality">
		<vs-table
			:sst="true"
			:total="totalItems"
			:max-items="maxItems"
			:data="qualityList"
			:currentPage="currentPage"
			pagination
			@change-page="setPageNumber"
		>
			<template slot="thead">
				<vs-th v-for="fil in field" :keyForSorting="fil.field">
					{{ $t(fil.title) }}
				</vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data">
					<template v-for="fil in field">
						<vs-td v-if="fil.field === 'name'">
							<router-link :to="'ticket/' + tr.id">
								{{ tr.name }}
							</router-link>
						</vs-td>

						<vs-td v-else-if="fil.field === 'client.full_name'">
							<router-link
								:to="
									`${pathToClient}/${deepFind(
										tr,
										'client.id'
									)}`
								"
							>
								{{ deepFind(tr, fil.field) || "---" }}
							</router-link>
						</vs-td>

						<vs-td v-else-if="fil.field === 'author.username'">
							<router-link
								v-if="tr[fil.field.split('.')[0]]"
								:to="
									`${pathToAuthor}/${deepFind(
										tr,
										'author.id'
									)}`
								"
								class="flex justify-center text-center"
							>
								{{ deepFind(tr, fil.field) || "---" }}
							</router-link>
						</vs-td>

						<vs-td v-else-if="fil.field === 'chat_messages_count'">
							<div class="counters__container">
								<span
									class="counter cursor-pointer"
									:class="{ blue: tr.author_is_chat_unread }"
									@click="openAuthorChat(tr.id)"
								>
									{{ tr.author_chat_messages_count || 0 }}
								</span>

								<span
									class="counter cursor-pointer"
									:class="{ warn: tr.is_chat_unread }"
									@click="
										$store.dispatch('openChat', {
											id: tr.id,
											disabled: true
										})
									"
								>
									{{ tr.chat_messages_count || 0 }}
								</span>
							</div>
						</vs-td>

						<vs-td v-else-if="fil.field === 'id'">
							<router-link :to="'ticket/' + tr.id">
								{{ deepFind(tr, fil.field) || "---" }}
							</router-link>
						</vs-td>

						<vs-td v-else-if="fil.field === 'site'">
							<span v-if="tr.client">
								{{ tr.client.site }}
							</span>
						</vs-td>

						<vs-td
							v-else-if="
								fil.field === 'manager.username' &&
									tr.manager !== null
							"
						>
							{{ tr.manager.username }}
						</vs-td>

						<vs-td
							v-else-if="
								fil.field === 'milestones' &&
									tr.manager !== null
							"
						>
							{{ tr.milestones_count }}
						</vs-td>

						<vs-td
							v-else-if="
								fil.field === 'price' && tr.manager !== null
							"
						>
							{{ tr.price_author }}
						</vs-td>

						<vs-td v-else-if="fil.field === 'task'">
							<span
								class="task cursor-pointer flex"
								v-if="tr[fil.field]"
								@click="
									selectedOrder = tr
									viewTaskPopup = true
								"
							>
								{{ tr[fil.field].date_time }}
							</span>

							<span
								class="task cursor-pointer"
								@click="
									idOrder = tr.id;
									activePrompt = true;
								"
								v-else
								>+</span
							>
						</vs-td>

						<vs-td v-else-if="tr[fil.field]">
							{{ tr[fil.field] }}
						</vs-td>
					</template>
				</vs-tr>
			</template>
		</vs-table>

		<CreateOrderTask
			:active.sync="activePrompt"
			:date.sync="date"
			:about.sync="about"
			@create-task="createTask(qualityList)"
		/>

		<ViewOrderTask
			:active.sync="viewTaskPopup"
			:order="selectedOrder"
		/>
	</vx-card>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import tasksListMixin from "@/mixins/tickets-list-mixin";
import notifier from "@/mixins/notifier";
import CreateOrderTask from "@/components/dialogs/CreateOrderTask.vue";
import ViewOrderTask from '@/components/dialogs/ViewOrderTask.vue'

const MAX_ITEMS = 5

export default {
	name: "QualityAssurance",
	components: { ViewOrderTask, CreateOrderTask },

	mixins: [databaseManager, notifier, tasksListMixin],

	data() {
		return {
			qualityList: [],
			about: "",
			idOrder: null,
			date: new Date(),
			activePrompt: false,
			limit: MAX_ITEMS,
			offset: 0,
			totalItems: 0,
			currentPage: 1,
			viewTaskPopup: false,
			selectedOrder: null,
			task: {},
			field: [
				{ field: "id", title: "№" },
				{ field: "created", title: "date" },
				{ field: "name", title: "topic" },
				{ field: "chat_messages_count", title: "" },
				{ field: "client.full_name", title: "client" },
				{ field: "site", title: "site" },
				{ field: "pages_number", title: "pagesCount" },
				{ field: "due_date", title: "dueDate" },
				{ field: "author.username", title: "author" },
				{ field: "task", title: "task" }
			]
		};
	},

	computed: {
		maxItems() {
			return MAX_ITEMS
		},
		pathToClient() {
			if (this.$store.state.auth.role === "admin") {
				return "client";
			} else if (this.$store.state.auth.role === "manager") {
				return "clientM";
			}
		},

		pathToAuthor() {
			if (this.$store.state.auth.role === "admin") {
				return "author";
			} else if (this.$store.state.auth.role === "manager") {
				return "authorM";
			}
		}
	},

	async mounted() {
		await this.getAssuranceList();
	},

	methods: {
		async openAuthorChat(id) {
			const model = await this.dbViewOrder(id);
			this.$store.dispatch("openChat", {
				authorChatId: model.author_chat_id,
				orderId: id,
				disabled: true
			});
		},

		async setPageNumber(data) {
			this.currentPage = data;
			await this.getAssuranceList()
		},

		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},

		async getAssuranceList() {
			try {
				const offset = (this.currentPage - 1) * this.limit;
				const res = await this.dbGetQualityProblemsList({
					offset,
					limit: this.limit
				});

				this.totalItems = res.total;


				this.qualityList = []
				for (let i = 0; i < res.items.length; i++) {
					this.qualityList[offset + i] = res.items[i]
				}
			} catch (err) {
				console.error(err);
			}
		},
	}
};
</script>

<style lang="scss">
@import "../assets/scss/vuexy/variables.scss";
@import "../assets/scss/vuexy/functions.scss";

.quality {
	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}

	.counters__container {
		display: flex;
		justify-content: space-between;
		width: 45px;

		.counter {
			padding: 5px;
			border-radius: 100%;
			font-weight: 600;
			width: 20px;
			height: 20px;
			font-size: 0.7rem;
			border: 1px solid #cfcfcf;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;

			&.warn {
				background-color: #f0ad4e;
				color: white;
				border-color: #f0ad4e;
			}

			&.blue {
				background-color: #005f95;
				color: white;
				border-color: #005f95;
			}
		}
	}
}
</style>
